var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"icon",class:`text-${_vm.color} bg-${_vm.background}`,style:(`
    font-size: ${_vm.fontSize}px;
    width: ${_vm.fontSize + 8}px;
    height: ${_vm.fontSize + 8}px;
    margin-top: ${_vm.marginTop}px;
    ${_vm.button && 'cursor: pointer;'}`),on:{"click":_vm.handleClick}},[_c('font-awesome-icon',{attrs:{"icon":[_vm.regular ? 'far' : 'fas', _vm.icon],"spin":_vm.spin,"size":_vm.fontIconSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }